import {Button, Card, CardBody, CardFooter, CardHeader, Input, Typography,} from "@material-tailwind/react";
import React, {useState} from "react";
import SelectInput from "../system/select";
import {getPersonsNameAndFamily} from "../../services/profile/profile";
import {submitAdminServiceVoipCall} from "../../services/admin_service/voip_call";
import {Toaster} from "../../helper/Toaster";


export function VoipCall() {

  const [callerPersonId, setCallerPersonId] = useState(null);
  const [calleePersonId, setCalleePersonId] = useState(null);
  const [duration, setDuration] = useState(5);

  const save = async () => {

    const data = {
      caller_person_id: callerPersonId,
      callee_person_id: calleePersonId,
      duration: duration,
    };
    let result;

    if (calleePersonId !== callerPersonId) {
      submitAdminServiceVoipCall(data);
    } else {
      Toaster.failure(null, "تماس گیرنده و طرف دوم نمی تواند یک نفر باشد!")
    }
  };

  return (
    <div className="mr-8">
      <Card className="pt-8 md:w-1/2">
        <CardHeader floated={true} shadow={false} className="rounded-none">
          <div className="mb-8 flex text-center items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">برقراری تماس</Typography>
          </div>
        </CardHeader>
        <CardBody className="overflow-x-auto w-full min-h-[500px]">
          <div className="grid grid-cols-1">

            <div className="flex w-full mb-4">
              <SelectInput
                label={"تماس گیرنده"}
                defaultValue={callerPersonId}
                // multiselect={false}
                autoLoadService={getPersonsNameAndFamily}
                autoLoadRender={({name, family}) => {
                  return name + " " + family
                }}
                onChange={setCallerPersonId}
              />
            </div>

            <div className="flex w-full mb-4">
              <SelectInput
                label={"طرف دوم"}
                defaultValue={calleePersonId}
                // multiselect={false}
                autoLoadService={getPersonsNameAndFamily}
                autoLoadRender={({name, family}) => {
                  return name + " " + family
                }}
                onChange={setCalleePersonId}
              />
            </div>

            <div className="flex w-full mb-4">
              <Input
                label="مدت تماس"
                type="number"
                variant="standard"
                step="5"
                value={duration}
                onChange={(e) => {
                  setDuration(parseInt(e.target.value));
                }}
              />
            </div>


          </div>
        </CardBody>
        <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>برقراری تماس</span>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}